export const PLANTUML_DEFAULT_URL = "https://plantuml.com/plantuml/";
